var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-col',_vm._l((_setup.offices),function(office){return _c('v-row',{key:office.id},[_c(_setup.OfficeAddress,{attrs:{"office":office}})],1)}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }